import { getStatusForLocation } from "./getStatusForLocation";

export default getStatusForLocation;
